module.exports = __webpack_public_path__ + "img/og-screen-3.5b603415.png";